module.exports = __webpack_public_path__ + "img/new11.cb1bd212.png";